import { useGetApPayeeInfoSuspense } from '@/context/services/ap_payee/ApPayee.service';
import { useMemo } from 'react';
import { DataMaster } from '../types';
import {
  GetNullDataMaster,
  GetMasterData,
} from '@/features/ap_payees/components/PayeeDetailDrawer/utils';

export const useGetApPayeeInfo = (apPayeeId: string) => {
  const { data, error, isLoading, refetch } =
    useGetApPayeeInfoSuspense(apPayeeId);
  const dataValue: DataMaster | undefined = useMemo(() => {
    return data ? GetMasterData(data) : GetNullDataMaster();
  }, [data]);

  return {
    data: dataValue,
    error: error,
    isLoading: isLoading,
    refetch,
  };
};
